<div class="modelos-dialog">
  <div class="modelos-dialog__header">
    <mat-icon class="header-icon">print</mat-icon>
    <h2 mat-dialog-title>Imprimir Inspeção</h2>
  </div>

  <mat-dialog-content class="modelos-dialog__content">
    <div class="modelos-table">
      <div class="modelos-table__header">
        <div class="col-radio"></div>
        <div class="col-descricao">Descrição</div>
      </div>

      <div class="modelos-table__body">
        <div class="modelos-table__row" *ngFor="let modelo of modelosExibidos"
          (click)="selecionarModelo(modelo.CodigoInspecaoModeloImpressao)">
          <div class="col-radio" (click)="$event.stopPropagation()">
            <mat-radio-button [checked]="modelo.CodigoInspecaoModeloImpressao === modeloSelecionadoId"
              [value]="modelo.CodigoInspecaoModeloImpressao"
              (change)="selecionarModelo(modelo.CodigoInspecaoModeloImpressao)" color="primary">
            </mat-radio-button>
          </div>
          <div class="col-descricao">
            {{ modelo.Descricao }}
          </div>
        </div>
      </div>
    </div>

    <mat-paginator *ngIf="data.modelos.length > 5" [length]="data.modelos.length" [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="onPageChange($event)" class="modelos-paginator">
    </mat-paginator>
  </mat-dialog-content>

  <div mat-dialog-actions align="start" class="modelos-dialog__actions">
    <button mat-flat-button type="button" class="btn-theme" (click)="fechar()" [disabled]="loading">
      <mat-icon>close</mat-icon>
      <span>Fechar</span>
    </button>

    <button mat-flat-button type="button" class="btn-theme" (click)="imprimir()"
      [disabled]="loading || !modeloSelecionadoId">
      <mat-icon *ngIf="!loading">check</mat-icon>
      <mat-spinner diameter="18" *ngIf="loading"></mat-spinner>
      <span>{{ 'Confirmar' }}</span>
    </button>
  </div>
</div>